import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroCteOs from '../../actions/cteos/adicionarFiltroCteOs'
import removerFiltroCteOs from '../../actions/cteos/removerFiltroCteOs'
import listarFiltrosCteOs from '../../actions/cteos/listarFiltrosCteOs'
import { alterouEmpresa } from '../../actions/empresa/alterarEmpresaSelecionada';
import FiltroBuscaCteOs from './FiltroBuscaCteOs'
import FiltroChaveValor from '../comum/FiltroChaveValor';
import { 
  FILTRO_DATA_EMISSAO_CTE_OS,
  FILTRO_TOMADOR,
  FILTRO_DESCRICAO_SERVICO_CTE_OS,
  FILTRO_ID_CTE_OS,
  FILTRO_NUMERO_CTE_OS,
  FILTRO_SERIE_CTE_OS,
  FILTRO_VALOR_SERVICO,
  FILTRO_STATUS_CTE_OS,
 } from '../../util/filtros'
import { statusTransmissaoCteOs } from '../../util/constantsUtil'

export class FiltroCteOs extends Component {
  componentDidMount () {
    if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
      this.props.listarFiltrosCteOs(this.props.empresaSelecionada.id)
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps)) {
      this.props.listarFiltrosCteOs(this.props.empresaSelecionada.id)
    }
  }


  adicionarFiltro (filtro) {
    this.props.adicionarFiltroCteOs(filtro)
  }

  removerFiltro (filtro) {
    this.props.removerFiltroCteOs(filtro)
  }

  render () {
    return (
      <React.Fragment>
        <div className="conteudo">          
          
          <FiltroBuscaCteOs
            filtro={FILTRO_DATA_EMISSAO_CTE_OS}
            opcoes={[new Date().getFullYear()]}
            isFiltroData={true}
          />          
          <FiltroBuscaCteOs
              filtro={FILTRO_TOMADOR}
              opcoes={[]}
              isNome={true}
            />
          <FiltroBuscaCteOs
              filtro={FILTRO_DESCRICAO_SERVICO_CTE_OS}
              opcoes={[]}
              isNome={true}
            />
          <FiltroBuscaCteOs
            filtro={FILTRO_ID_CTE_OS}
            isNumero={true}
          />
          <FiltroBuscaCteOs
              filtro={FILTRO_NUMERO_CTE_OS}
              opcoes={[]}
              isNome={true}
            />
          <FiltroBuscaCteOs
            filtro={FILTRO_SERIE_CTE_OS}
            isNumero={true}
          />
          <FiltroBuscaCteOs 
            filtro={FILTRO_VALOR_SERVICO}
            opcoes={[]}
            isValorMonetario={true}
          />
          <FiltroChaveValor
              filtro={FILTRO_STATUS_CTE_OS}
              opcoes={statusTransmissaoCteOs}
              filtrosAdicionados={this.props.filtrosAdicionados}
              adicionarFiltro={this.adicionarFiltro.bind(this)}
              removerFiltro={this.removerFiltro.bind(this)}
            />
        </div>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = state => ({  
  filtrosAdicionados: state.filtrosAdicionadosCteOs,
  empresaSelecionada: state.empresaSelecionada,

})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroCteOs,
    removerFiltroCteOs,
    listarFiltrosCteOs
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroCteOs)
